import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.QbEstimateDTO')
export class QbEstimateDTO extends AbstractModel {
    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'qbTxnId')
    qbTxnId?: string;

    @JsonProperty(Number, 'salesUserId')
    salesUserId?: number;

    @JsonProperty(String, 'salesUserName')
    salesUserName?: string;

    @JsonProperty(Number, 'projectId')
    projectId?: number;

    @JsonProperty(String, 'projectNumber')
    projectNumber?: string;

    @JsonProperty(String, 'projectName')
    projectName?: string;

    @JsonProperty(DateConverter, 'txnDate')
    txnDate?: Date;

    @JsonProperty(Number, 'originalAmount')
    originalAmount?: number;

    @JsonProperty(Number, 'amount')
    amount?: number;

    @JsonProperty(Number, 'percentage')
    percentage?: number;

    @JsonProperty(Boolean, 'userModified')
    userModified?: boolean;

    @JsonProperty(Boolean, 'createdManually')
    createdManually?: boolean;

    @JsonProperty(Number, 'parentId')
    parentId?: number;

    @JsonProperty(String, 'txnStatus')
    txnStatus?: string;
}

